<template>
  <el-tooltip placement="bottom" effect="light">
    <div slot="content">

      <!-- 取消原因 -->
      <p class="error-tip" v-if="status=='已取消'">
        由 <span v-if="flow.cancelUser">{{ flow.cancelUser.name }}</span><span v-else> / </span> 在 <span v-if="flow.cancelTime">{{ flow.cancelTime }}</span><span>/</span> 取消：{{ flow.remark }}
      </p>


      <el-table :data="getRowArpproval(approvals)" style="width: 100%" v-loading="loading">
        <el-table-column prop="user.name" label="审批人">
        </el-table-column>
        <!-- <el-table-column label="职务">
          <template slot-scope="scope">
            {{ scope.row.user.childDept }}
          </template>
        </el-table-column> -->
        <el-table-column label="说明" align="center">
          <template slot-scope="scope">
            <span :class="{
                      'status-success': scope.row.status=='同意',
                      'status-fail': scope.row.status=='拒绝',
                    }">
              {{ scope.row.remark?scope.row.remark:"无" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="审批结果" width="80px" align="center">
          <template slot-scope="scope">
            <strong :class="{
                      'status-success': scope.row.status=='同意',
                      'status-fail': scope.row.status=='拒绝',
                    }">
              {{ scope.row.status?scope.row.status:"暂未审批" }}
            </strong>
          </template>
        </el-table-column>
        <el-table-column label="审批时间" prop="approvalTime" width="120px"></el-table-column>
      </el-table>

    </div>
    <el-button size="mini" class="el-flow-btn" :class="{
                      'status-success': status=='审批通过',
                      'status-fail': status=='已拒绝',
                      'status-cancle': status=='已取消',
                    }">{{
      status }}</el-button>

  </el-tooltip>
</template>

<script>
  export default {
    props: ['approvals', 'status', 'flow'],
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      // 增加审批人
      addApproval(row) {
        console.log(row)
      },
      // 格式化审批人
      getRowArpproval(approvals) {
        let ap = []
        for (var i = 0; i < approvals.length; i++) {
          if (approvals[i].user) {
            ap.push(approvals[i])
          }
        }
        return ap
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ApprovalStatus.vue